<template>
  <v-dialog v-model="dialog" persistent width="840" scrollable>
    <!-- ACTIVATOR BUTTON -->
    <v-btn small slot="activator" color="primary" flat>
      <v-icon small class="pr-2">mdi-bank-transfer</v-icon>Account to Account
      Transfer
    </v-btn>
    <v-card>
      <v-card-title
        class="title font-weight-regular justify-space-between grey--text text--darken-2"
      >
        <v-layout row wrap align-center>
          <v-icon class="pr-2">mdi-bank-transfer</v-icon>
          <span>Account To Account Transfer</span>
          <v-spacer />
          <v-avatar
            color="blue lighten-2"
            class="body-2 white--text font-weight-bold"
            size="24"
            v-text="formStep + 1"
          ></v-avatar>
        </v-layout>
      </v-card-title>

      <v-divider></v-divider>
      <v-card-text class="pa-0">
        <v-window v-model="formStep">
          <!-- EMMITER OR RECIPIENT CHOICE -->
          <v-window-item :value="0">
            <v-card-text class="text-xs-center">
              <v-layout row wrap align-center justify-center class="pb-4">
                <v-flex xs12 class="pa-4">
                  <span class="caption grey--text text--darken-1">
                    Select if
                    <i>{{ companyBalance.company_name }}</i> is
                    <strong>emitter</strong> or <strong>recipient</strong> of
                    the transfer.
                  </span>
                </v-flex>

                <v-flex xs12 class="pa-2">
                  <v-btn
                    depressed
                    @click="selectEmmiterOrRecipient(true)"
                    color="primary"
                    style="width: 190px;"
                  >
                    <v-icon color="white" class="pr-2"
                      >mdi-bank-transfer-out</v-icon
                    >
                    <span style="color: white;">Emmiter</span>
                  </v-btn>
                </v-flex>

                <v-flex xs12 class="pa-2">
                  <v-btn
                    depressed
                    @click="selectEmmiterOrRecipient(false)"
                    color="amber darken-1"
                    style="width: 190px;"
                  >
                    <v-icon color="white" class="pr-2"
                      >mdi-bank-transfer-in</v-icon
                    >
                    <span style="color: white;">Recipient</span>
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-window-item>

          <!-- FROM TO FORM -->
          <v-window-item :value="1">
            <v-card-text v-if="!transferDone">
              <v-layout row wrap class="text-xs-center px-4">
                <!-- FROM -->
                <v-flex xs5>
                  <v-layout row wrap justify-center class="pl-4 pb-4">
                    <v-flex xs12 class="text-xs-center">
                      <span class="grey--text text--darken-1 font-weight-bold"
                        >From</span
                      >
                    </v-flex>
                  </v-layout>
                  <!-- FROM COMPANY BALANCE ID -->
                  <v-flex xs12>
                    <v-autocomplete
                      :items="availableCompanyBalances"
                      :item-disabled="set_disabled_from"
                      item-value="id"
                      item-text="company_name"
                      browser-autocomplete="noautocomplete"
                      label="From"
                      small-chips
                      chips
                      :disabled="accountIsEmmiter"
                      v-model="
                        companyBalanceTransfer.emitter_company_balance_id
                      "
                    >
                      <template slot="label">
                        <v-icon size="14" class="pr-1" color="#757575"
                          >mdi-bank-transfer-out</v-icon
                        >From Account
                      </template>

                      <template slot="item" slot-scope="props">
                        <v-list-tile-content>
                          <v-list-tile-title style="font-size: 12px;">
                            {{ truncate(props.item.company_name, 40) }}
                            <span style="float: right;"
                              >({{
                                getCodeFromId(props.item.currency_id)
                              }})</span
                            >
                          </v-list-tile-title>
                          <v-list-tile-sub-title
                            style="position: relative; top: -8px;"
                          >
                            <v-label>
                              Account Balance:
                              <strong>{{
                                inCurrencyFromId(
                                  props.item.currency_id,
                                  props.item.current_amount
                                )
                              }}</strong>
                            </v-label>
                          </v-list-tile-sub-title>
                        </v-list-tile-content>
                      </template>
                    </v-autocomplete>
                  </v-flex>

                  <!-- FROM AMOUNT & CURRRENCY -->
                  <v-flex xs12>
                    <v-layout row wrap>
                      <v-flex xs7>
                        <v-text-field
                          type="number"
                          v-model="companyBalanceTransfer.emitter_amount"
                          :prefix="
                            currencyIdFrom
                              ? getSymbolFromCode(getCodeFromId(currencyIdFrom))
                              : ''
                          "
                        >
                          <template slot="label">
                            <v-icon size="14" class="pr-1" color="#757575"
                              >mdi-cash</v-icon
                            >Amount
                          </template>
                        </v-text-field>
                      </v-flex>
                      <v-flex xs5 class="pl-3">
                        <v-autocomplete
                          dense
                          :items="currencies"
                          item-value="id"
                          item-text="name"
                          disabled
                          background-color="white"
                          browser-autocomplete="noautocomplete"
                          label="Currency"
                          :value="currencyIdFrom"
                        >
                          <template slot="label"
                            >{{
                              currencyIdFrom
                                ? getSymbolFromCode(
                                    getCodeFromId(currencyIdFrom)
                                  ) + " "
                                : ""
                            }}Currency</template
                          >
                        </v-autocomplete>
                      </v-flex>
                    </v-layout>
                  </v-flex>

                  <!-- EMITTER TRANSFERT DATE -->
                  <v-flex xs12>
                    <v-menu
                      ref="menu"
                      :close-on-content-click="true"
                      :nudge-right="40"
                      lazy
                      transition="scale-transition"
                      offset-y
                      full-width
                      min-width="290px"
                    >
                      <v-text-field
                        slot="activator"
                        :value="
                          companyBalanceTransfer.emitter_transfer_date
                            ? timeToDate(
                                companyBalanceTransfer.emitter_transfer_date
                              )
                            : null
                        "
                        label="Transfer Date"
                        readonly
                      >
                        <template slot="label">
                          <v-icon size="14" class="pr-1" color="#757575"
                            >event</v-icon
                          >Transfer Date
                        </template>
                      </v-text-field>
                      <v-date-picker
                        v-model="companyBalanceTransfer.emitter_transfer_date"
                        no-title
                        scrollable
                        first-day-of-week="1"
                      />
                    </v-menu>
                  </v-flex>

                  <!-- Balance Before and After -->
                  <v-layout
                    justify-center
                    row
                    wrap
                    v-if="
                      companyBalanceTransfer.emitter_company_balance_id &&
                      emitterCompanyBalance &&
                      companyBalanceTransfer.recipient_amount &&
                      companyBalanceTransfer.emitter_amount
                    "
                  >
                    <span class="caption">
                      <v-icon color="blue" size="14" class="pr-1">info</v-icon>
                      <span class="pr-2">Account Balance:</span>
                      <strong>{{
                        inCurrencyFromId(
                          emitterCompanyBalance.currency_id,
                          emitterCompanyBalance.current_amount
                        )
                      }}</strong>
                      <v-icon color="success" small class="px-2"
                        >mdi-transfer-right</v-icon
                      >
                      <strong>{{
                        inCurrencyFromId(
                          emitterCompanyBalance.currency_id,
                          parseFloat(emitterCompanyBalance.current_amount) -
                            parseFloat(companyBalanceTransfer.emitter_amount)
                        )
                      }}</strong>
                    </span>
                  </v-layout>
                </v-flex>
                <!-- MIDDLE ARROW ICON -->
                <v-flex xs2>
                  <v-layout row wrap fill-height align-center>
                    <v-flex xs12 style="position: relative; top: 22px;">
                      <v-icon size="36" color="success"
                        >mdi-transfer-right</v-icon
                      >
                      <br />
                      <v-label>
                        Exch. Rate:
                        <span class="font-weight-bold"
                          >x{{ exchangeRate }}</span
                        >
                      </v-label>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <!-- TO -->
                <v-flex xs5>
                  <v-layout row wrap justify-center class="pr-4 pb-4">
                    <v-flex xs12 class="text-xs-center">
                      <span class="grey--text text--darken-1 font-weight-bold"
                        >To</span
                      >
                    </v-flex>
                  </v-layout>
                  <!-- TO COMPANY BALANCE ID -->
                  <v-flex xs12>
                    <v-autocomplete
                      :items="availableCompanyBalances"
                      :item-disabled="set_disabled_to"
                      item-value="id"
                      item-text="company_name"
                      browser-autocomplete="noautocomplete"
                      label="To"
                      small-chips
                      chips
                      :disabled="accountIsEmmiter == false"
                      v-model="
                        companyBalanceTransfer.recipient_company_balance_id
                      "
                    >
                      <template slot="label">
                        <v-icon size="14" class="pr-1" color="#757575"
                          >mdi-bank-transfer-out</v-icon
                        >To Account
                      </template>

                      <template slot="item" slot-scope="props">
                        <v-list-tile-content>
                          <v-list-tile-title style="font-size: 12px;">
                            {{ truncate(props.item.company_name, 40) }}
                            <span style="float: right;"
                              >({{
                                getCodeFromId(props.item.currency_id)
                              }})</span
                            >
                          </v-list-tile-title>
                          <v-list-tile-sub-title
                            style="position: relative; top: -8px;"
                          >
                            <v-label>
                              Account Balance:
                              <strong>{{
                                inCurrencyFromId(
                                  props.item.currency_id,
                                  props.item.current_amount
                                )
                              }}</strong>
                            </v-label>
                          </v-list-tile-sub-title>
                        </v-list-tile-content>
                      </template>
                    </v-autocomplete>
                  </v-flex>
                  <!-- TO AMOUNT & CURRRENCY -->
                  <v-flex xs12>
                    <v-layout row wrap>
                      <v-flex xs7>
                        <v-text-field
                          type="number"
                          v-model="companyBalanceTransfer.recipient_amount"
                          :prefix="
                            currencyIdTo
                              ? getSymbolFromCode(getCodeFromId(currencyIdTo))
                              : ''
                          "
                        >
                          <template slot="label">
                            <v-icon size="14" class="pr-1" color="#757575"
                              >mdi-cash</v-icon
                            >Amount
                          </template>
                        </v-text-field>
                      </v-flex>
                      <v-flex xs5 class="pl-3">
                        <v-autocomplete
                          dense
                          :items="currencies"
                          item-value="id"
                          item-text="name"
                          disabled
                          background-color="white"
                          browser-autocomplete="noautocomplete"
                          label="Currency"
                          :value="currencyIdTo"
                        >
                          <template slot="label"
                            >{{
                              currencyIdTo
                                ? getSymbolFromCode(
                                    getCodeFromId(currencyIdTo)
                                  ) + " "
                                : ""
                            }}Currency</template
                          >
                        </v-autocomplete>
                      </v-flex>
                    </v-layout>
                  </v-flex>

                  <!-- RECIPIENT TRANSFERT DATE -->
                  <v-flex xs12>
                    <v-menu
                      ref="menu"
                      :close-on-content-click="true"
                      :nudge-right="40"
                      lazy
                      transition="scale-transition"
                      offset-y
                      full-width
                      min-width="290px"
                    >
                      <v-text-field
                        slot="activator"
                        :value="
                          companyBalanceTransfer.recipient_transfer_date
                            ? timeToDate(
                                companyBalanceTransfer.recipient_transfer_date
                              )
                            : null
                        "
                        label="Transfer Date"
                        readonly
                      >
                        <template slot="label">
                          <v-icon size="14" class="pr-1" color="#757575"
                            >event</v-icon
                          >Transfer Date
                        </template>
                      </v-text-field>
                      <v-date-picker
                        v-model="companyBalanceTransfer.recipient_transfer_date"
                        no-title
                        scrollable
                        first-day-of-week="1"
                      />
                    </v-menu>
                  </v-flex>

                  <!-- Balance Before and After -->
                  <v-layout
                    justify-center
                    row
                    wrap
                    v-if="
                      companyBalanceTransfer.recipient_company_balance_id &&
                      recipientCompanyBalance &&
                      companyBalanceTransfer.emitter_amount &&
                      companyBalanceTransfer.recipient_amount
                    "
                  >
                    <span class="caption">
                      <v-icon color="blue" size="14" class="pr-1">info</v-icon>
                      <span class="pr-2">Account Balance:</span>
                      <strong>{{
                        inCurrencyFromId(
                          recipientCompanyBalance.currency_id,
                          recipientCompanyBalance.current_amount
                        )
                      }}</strong>
                      <v-icon color="success" small class="px-2"
                        >mdi-transfer-right</v-icon
                      >
                      <strong>{{
                        inCurrencyFromId(
                          recipientCompanyBalance.currency_id,
                          parseFloat(recipientCompanyBalance.current_amount) +
                            parseFloat(companyBalanceTransfer.recipient_amount)
                        )
                      }}</strong>
                    </span>
                  </v-layout>
                </v-flex>
              </v-layout>
              <v-layout row wrap class="px-4 pt-4">
                <v-flex xs12>
                  <v-subheader class="px-0">
                    <v-icon small class="pr-2">notes</v-icon>Transfer Notes
                  </v-subheader>
                </v-flex>
                <v-flex xs12>
                  <v-textarea
                    auto-grow
                    class="pt-0"
                    v-model="companyBalanceTransfer.notes"
                    background-color="white"
                    rows="2"
                  />
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-window-item>
        </v-window>
        <!-- <json-viewer :value="availableCompanyBalances" sort></json-viewer>
        <json-viewer :value="companyBalance" sort></json-viewer>-->
      </v-card-text>

      <v-card-actions>
        <v-btn color="error" small flat @click="dialog = false">
          <v-icon small class="pr-2">close</v-icon>
          {{ transferDone ? "Close" : "Cancel" }}
        </v-btn>

        <v-btn
          small
          color="grey darken-1"
          v-show="formStep == 1"
          flat
          @click="formStep--"
        >
          <v-icon small class="pr-2">mdi-arrow-left</v-icon>Back
        </v-btn>

        <v-spacer></v-spacer>
        <v-btn
          v-show="!transferDone"
          color="success"
          class="white--text"
          small
          depressed
          :disabled="!canSave"
          @click="submitCompanyBalanceTransfer()"
        >
          <v-icon small class="pr-2">mdi-shield-check</v-icon>Confirm Account
          Transfer
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";
import currency from "../../../mixins/currency.js";
import date from "../../../mixins/date.js";
import JsonViewer from "vue-json-viewer";
import CREATE_COMPANY_BALANCE_TRANSFER from "../../../graphql/company_balance_transfer/create.gql";

export default {
  name: "companyAccountTransferForm",
  mixins: [currency, date],
  components: { JsonViewer },
  props: {
    companyBalance: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      dialog: false,
      transferDone: false,
      companyBalanceTransfer: null,
      formStep: 0,
      accountIsEmmiter: true,
    };
  },
  computed: {
    ...mapGetters("commonStore", ["currencies", "companyBalances"]),
    filteredCompanyBalances() {
      let cbs = this.companyBalances.filter(cb => cb.subsidiary_company_id == this.companyBalance.subsidiary_company_id)
      // console.log(this.companyBalances)
      // console.log(this.companyBalance.subsidiary_company_id)
      // console.log(cbs)

      return cbs
    },
    emitterCompanyBalance() {
      if (this.companyBalanceTransfer.emitter_company_balance_id) {
        return this.filteredCompanyBalances.find(
          (cb) =>
            cb.id == this.companyBalanceTransfer.emitter_company_balance_id
        );
      }

      return null;
    },
    recipientCompanyBalance() {
      if (this.companyBalanceTransfer.recipient_company_balance_id) {
        return this.filteredCompanyBalances.find(
          (cb) =>
            cb.id == this.companyBalanceTransfer.recipient_company_balance_id
        );
      }

      return null;
    },
    availableCompanyBalances() {
      let arr_same_company = [{ header: "From the same company" }];
      let arr_others_company = [{ header: "Others companies" }];

      this.filteredCompanyBalances.forEach((cb) => {
        if (cb.company_id == this.companyBalance.company.id) {
          // Belongs to the Same company
          arr_same_company.push(cb);
        } else {
          // Belongs to another company and only if currency is the same as the company balance props
          if (cb.currency_id == this.companyBalance.currency_id) {
            arr_others_company.push(cb);
          }
        }
      });

      if (arr_same_company.length === 1) return arr_others_company;

      if (arr_others_company.length === 1) return arr_same_company;

      let arr_concat = arr_same_company.concat(arr_others_company);

      return arr_concat;

      //return this.filteredCompanyBalances; //return this.filteredCompanyBalances.filter(e => e.id !== this.companyBalance.id);
    },
    currencyIdFrom() {
      if (this.emitterCompanyBalance) {
        return this.emitterCompanyBalance.currency_id;
      }
      return null;
    },
    currencyIdTo() {
      if (this.recipientCompanyBalance) {
        return this.recipientCompanyBalance.currency_id;
      }
      return null;
    },
    exchangeRate() {
      if (
        this.companyBalanceTransfer.emitter_amount == 0 ||
        this.companyBalanceTransfer.recipient_amount == 0
      )
        return "--";
      return (
        this.companyBalanceTransfer.recipient_amount /
        this.companyBalanceTransfer.emitter_amount
      ).toFixed(2);
    },
    canSave() {
      if (
        this.currencyIdFrom == this.currencyIdTo &&
        this.companyBalanceTransfer.emitter_amount !=
          this.companyBalanceTransfer.recipient_amount
      )
        return false;

      if (
        this.companyBalanceTransfer.emitter_company_balance_id == "" ||
        this.companyBalanceTransfer.recipient_company_balance_id == ""
      ) {
        return false;
      }

      if (
        this.companyBalanceTransfer.emitter_amount <= 0 ||
        this.companyBalanceTransfer.recipient_amount <= 0
      ) {
        return false;
      }

      if (
        this.companyBalanceTransfer.emitter_transfer_date == "" ||
        this.companyBalanceTransfer.recipient_transfer_date == ""
      ) {
        return false;
      }

      return true;
    },
  },
  methods: {
    truncate(input, size) {
      if (input.length > size) return input.substring(0, size) + "...";
      else return input;
    },
    selectEmmiterOrRecipient(emitter) {
      this.accountIsEmmiter = emitter;
      this.resetcompanyBalanceTransfer();
      if (this.accountIsEmmiter) {
        this.companyBalanceTransfer.emitter_company_balance_id = this.companyBalance.id;
      } else {
        this.companyBalanceTransfer.recipient_company_balance_id = this.companyBalance.id;
      }

      this.formStep++;
    },
    set_disabled_from(item) {
      return (
        item.id == this.companyBalanceTransfer.recipient_company_balance_id
      );
    },
    set_disabled_to(item) {
      return item.id == this.companyBalanceTransfer.emitter_company_balance_id;
    },
    resetcompanyBalanceTransfer() {
      this.companyBalanceTransfer = {
        emitter_amount: 0,
        recipient_amount: 0,
        emitter_company_balance_id: "",
        recipient_company_balance_id: "",
        emitter_transfer_date: new Date().toISOString().substr(0, 10),
        recipient_transfer_date: new Date().toISOString().substr(0, 10),
        notes: "",
      };
    },
    resetForm() {
      this.transferDone = false;
      this.resetcompanyBalanceTransfer();
    },
    submitCompanyBalanceTransfer() {
      if (typeof this.companyBalanceTransfer.emitter_amount != "number") {
        this.companyBalanceTransfer.emitter_amount = parseFloat(
          this.companyBalanceTransfer.emitter_amount
        );
      }
      if (typeof this.companyBalanceTransfer.recipient_amount != "number") {
        this.companyBalanceTransfer.recipient_amount = parseFloat(
          this.companyBalanceTransfer.recipient_amount
        );
      }
      console.log("apres", this.companyBalanceTransfer);
      this.sendMutation(
        "created",
        "company_balance_transfer",
        CREATE_COMPANY_BALANCE_TRANSFER,
        this.companyBalanceTransfer
      ).then(() => {
        this.resetcompanyBalanceTransfer();
        this.dialog = false;
      });
    },
  },
  watch: {},
  created() {
    this.resetForm();
  },
};
</script>
